export enum TourActions {
  SLICE_NAME = '@TOURS'
}
